import { Element } from 'react-bulma-components';

export interface SelectionIndicatorProps {
  selected: number;
  total: number;
}

export function SelectionIndicator({
  selected,
  total,
}: SelectionIndicatorProps) {
  return (
    <Element>
      <span>
        Selected {selected} of {total}
      </span>
    </Element>
  );
}

export default SelectionIndicator;
